/* eslint-disable no-console */
import {dataAPI} from './api';

export function loadDataFromAPI (accessToken) {
    let id = localStorage.getItem ('id');
    return new Promise ((resolve)  => {
        dataAPI({
            method  : 'get',
            url     : `loadData?id=` + id,
            headers : {
                Authorization : 'Bearer ' + accessToken
            }
        }
        ).then(dataSuccess => {
            //reintroduce query string into url
            let newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${`id=` + id}`;
            window.history.pushState ({path : newurl}, '', newurl);
            resolve(dataSuccess);
            //}
        }
        ).catch((error) => {
            resolve(error.response.status);
            console.log("Search error ", error.response.status);

        });
    });
}



// WEBPACK FOOTER //
// ./src/APIs/dataHelper.js